// extracted by mini-css-extract-plugin
module.exports = {"UserMenu":"UserMenu_DKQIs","UserMenuBadge":"UserMenuBadge_BIeO2"};